import axios from "axios";
import { createContext, useState } from "react";
import { toast } from "react-toastify";




export let UserContext = createContext();


export default function UserContextProvider(props) {


   const [loggedUser, setLoggedUser] = useState({});
   const [admin, setAdmin] = useState(false);
   const [moderator, setModerator] = useState(false);
   const [completeInfoUser, setCompleteInfoUser] = useState(true);

   const [userToken, setUserToken] = useState(localStorage.getItem("token"));
   const [error, setError] = useState(null);
   const [loading, setLoading] = useState(false)
   const [role, setRole] = useState("");
   const [user, setUser] = useState({});
   const [users, setUsers] = useState([]);
   const [userData, setUserData] = useState({});
   const [addNewUser, setAddNewUser] = useState({});
   const [filter, setFilter] = useState("");
   const [countItem, setCountItem] = useState(10);
   const [userPageCount, setUserPageCount] = useState(0);

   const header = {
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }

   async function getSpecificUser(id) {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/users/${id}`, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               setUser(data.user);
            }
         })
         .catch((error) => {
            toast.error(error.response.data.message)
         })
   }


   async function getDataCount() {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/users/userCount`, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               setUserData(data.user_Data);
               setAddNewUser(data.user_Data.NewUsers)
            }
         })
         .catch((error) => {
            toast.error(error.response.data.message)
         })
   }


   async function getTypeUsers(item) {
      setFilter(item)
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/users?filter=${item}`, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               setUsers(data.users);
               setUserPageCount(data.metadata.numberOfPages);
            }
         })
         .catch((error) => {
            toast.error(error.response.data.message)
         })
   }


   async function searchUserName(search) {
      if (search.length >= 3) {
         await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/users?keyword=${search}`, { headers: header })
            .then(({ data }) => {
               if (data.message === "success") {
                  setUsers(data.users);
                  setUserPageCount(data.metadata.numberOfPages);
               }
            })
            .catch((error) => {
               toast.error(error.response.data.message)
            })
      }
   }


   const fetchData = async (currentPage) => {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/users?filter=${filter}&page=${currentPage}`, { headers: header })
         .then(({ data }) => {
            setUsers(data.users);
            setUserPageCount(data.metadata.numberOfPages);
         })
         .catch((error) => {
            toast.error(error.response.data.message)
         })
   }


   const handlePageClick = (data) => {
      fetchData(data?.selected + 1)
   }


   const getNewUser = () => {
      setUsers(addNewUser)
   }


   return (
      <>
         <UserContext.Provider
            value={{
               user,
               setUser,

               userPageCount,

               countItem,
               setCountItem,

               userData,
               setUserData,

               filter,
               setFilter,

               addNewUser,
               setAddNewUser,

               users,
               setUsers,

               role,
               setRole,

               loggedUser,
               setLoggedUser,

               userToken,
               setUserToken,

               admin,
               setAdmin,

               moderator,
               setModerator,

               error,
               setError,

               loading,
               setLoading,

               completeInfoUser,
               setCompleteInfoUser,

               getSpecificUser,
               getNewUser,
               handlePageClick,
               searchUserName,
               getTypeUsers,
               getDataCount
            }}>
            {props.children}
         </UserContext.Provider>
      </>
   )
}